module.exports = __webpack_public_path__ + "static/integration/d2l/img/ally-icon-indicator-low.6f607b35ae94f095c20f15d2362d2044.svg";